import { t } from '@lingui/macro';
import React, { useContext } from 'react';

import { FormOptionsContext } from '$/components/ui/Form';
import CardMain from '$/components/Interactions/cards/CardMain';
import { useCardContext } from '$/components/Interactions/cards/CardContext';

export const IoradCardBody: React.FC = () => {
  const { interaction } = useCardContext();
  const { onSubmit } = useContext(FormOptionsContext);

  if (!interaction.details) return null;
  const { buttonText } = interaction.details;

  return (
    <CardMain.Body>
      <CardMain.SubmitButton
        onClick={(): void => {
          onSubmit();
        }}
      >
        {buttonText || t`View`}
      </CardMain.SubmitButton>
    </CardMain.Body>
  );
};
